/* eslint-disable no-restricted-imports */
/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import { Link } from "react-router-dom";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import Dropdown from "react-bootstrap/Dropdown";
import { DropdownTopbarItemToggler } from "../../../../_partials/dropdowns";
import useAdobeDataLayer from "../../../../../app/sustell_15/analytics/adobeDataLayer";

// import useUserData from "../../../../../app/modules/Auth/getAuthUserData";
// import Auth from "@aws-amplify/auth";
// import { useIntl } from 'react-intl';
import { useIntl } from "../../../../i18n/customUseIntl";
import { headerMenusStyles } from "../../../_core/MaterialThemeProvider";
import { Settings01 as NewAccountCircleIcon } from "@untitledui/icons";
import featureFlags from "../../../../../app/sustell_15/utils/featureFlags";

const UserProfileDropdown = () => {
  // const user = useUserData();
  const intl = useIntl();
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const classes = headerMenusStyles() as any;
  const { ctaClickEvent } = useAdobeDataLayer();
  return (
    <>
      <Link
        to="/v2/profile"
        onClick={() =>
          ctaClickEvent(
            "/v2/profile",
            "link",
            "User Profile",
            "Main Menu",
            "Header",
          )
        }
        className={`${classes.mainMenuItemIcon}`}
      >
        <NewAccountCircleIcon
          className={`${classes.mainMenuItemProfile}`}
          width={20}
          height={20}
        />
      </Link>
    </>
  );
};

export default UserProfileDropdown;
